import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class AnpEnChiffreService {

  constructor(private http:HttpClient,private global:Global) { }
  httpOptions = {
    headers: new HttpHeaders({
      "accept": "application/json;odata=Nometadata",
      "content-type": "application/json;odata=verbose"
    })
  };
  urlAgence = this.global._Url;
  getGhaphData(lg,code){
    return this.http.get(lg.url+"/_api/web/lists/GetByTitle('ANPEnChiffres')/items?$filter=Code eq '"+code
        +"'&$select=*",this.httpOptions);
  }
}
